import {API_URL, API_URL_V2} from '../constants/index.js';
import {
    DASHBOARD_ACTIVITY,
    DASHBOARD_ACTIVITY_ERROR,
    DASHBOARD_ACTIVITY_SUCCESS,
    DASHBOARD_DINNING,
    DASHBOARD_DINNING_ERROR,
    DASHBOARD_DINNING_SUCCESS,
    DASHBOARD_REPAIRS,
    DASHBOARD_REPAIRS_ERROR,
    DASHBOARD_REPAIRS_SUCCESS
} from '../constants/dashboardConstants';

//#region  -- GET DASHBOARD ACTIVITIES 
export function getDashboardActivities(data) {
    return {
        type: DASHBOARD_ACTIVITY,
        data
    }
};

export function getDashboardActivitiesSuccess(data) {
    return {
        type: DASHBOARD_ACTIVITY_SUCCESS,
        data
    }
};

export function getDashboardActivityError(data) {
    return {
        type: DASHBOARD_ACTIVITY_ERROR,
        data
    }
};

export function GetAllDashboardActivities(idCommunity) {
    return dispatch => {
        dispatch(getDashboardActivities());
        
        fetch(API_URL+'activities/dashboard',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'CommunityId': idCommunity, 
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDashboardActivitiesSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getDashboardActivityError(error));

            })
    }
};

export function GetAllDashboardActivitiesV2(idCommunity) {
    return dispatch => {
        dispatch(getDashboardActivities());
        
        fetch(API_URL_V2+'activities/dashboard',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'CommunityId': idCommunity, 
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDashboardActivitiesSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getDashboardActivityError(error));

            })
    }
};
//#endregion

//#region  -- GET DASHBOARD REPAIRS 
export function getDashboardRepairs(data) {
    return {
        type: DASHBOARD_REPAIRS,
        data
    }
};

export function getDashboardRepairsSuccess(data) {
    return {
        type: DASHBOARD_REPAIRS_SUCCESS,
        data
    }
};

export function getDashboardRepairsError(data) {
    return {
        type: DASHBOARD_REPAIRS_ERROR,
        data
    }
};

export function GetAllDashboardRepairs(idCommunity) {
    return dispatch => {
        dispatch(getDashboardRepairs());
        
        fetch(API_URL+'workorders/dashboard',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'CommunityId': idCommunity, 
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDashboardRepairsSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getDashboardRepairsError(error));

            })
    }
};

export function GetAllDashboardRepairsV2(idCommunity) {
    return dispatch => {
        dispatch(getDashboardRepairs());
        
        fetch(API_URL_V2+'workorders/dashboard',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'CommunityId': idCommunity, 
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDashboardRepairsSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getDashboardRepairsError(error));

            })
    }
};
//#endregion

//#region  -- GET DASHBOARD DINNER 
export function getDashboardDinning(data) {
    return {
        type: DASHBOARD_DINNING,
        data
    }
};

export function getDashboardDinningSuccess(data) {
    return {
        type: DASHBOARD_DINNING_SUCCESS,
        data
    }
};

export function getDashboardDinningError(data) {
    return {
        type: DASHBOARD_DINNING_ERROR,
        data
    }
};

export function GetAllDashboardDinning(idCommunity) {
    return dispatch => {
        dispatch(getDashboardDinning());
        
        fetch(API_URL+'dinings/dashboard',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'CommunityId': idCommunity, 
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDashboardDinningSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getDashboardDinningError(error));

            })
    }
};

export function GetAllDashboardDinningV2(idCommunity) {
    return dispatch => {
        dispatch(getDashboardDinning());
        
        fetch(API_URL_V2+'dinings/dashboard',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'CommunityId': idCommunity, 
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDashboardDinningSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getDashboardDinningError(error));

            })
    }
};
//#endregion
